/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

import React from 'react';

import { googlePlayLink } from 'constants/urls';

const storeBadges: Record<string, string> = {
  cn: '/google-play/cn.png',
  de: '/google-play/de.png',
  enUS: '/google-play/en-us.png',
  es: '/google-play/es.png',
  fr: '/google-play/fr.png',
  pl: '/google-play/pl.png',
  pt: '/google-play/pt.png',
  th: '/google-play/th.png',
  nl: '/google-play/nl.png',
  vi: '/google-play/vi.png',
  ja: '/google-play/ja.png',
  it: '/google-play/it.png',
};

import s from './styles.module.scss';

interface GooglePlayBadgeProps {
  language?: string;
}

const GooglePlayBadge = ({ language = 'en-us' }: GooglePlayBadgeProps) => (
  <a className={s.badge} href={googlePlayLink} target="_blank" rel="noopener noreferrer">
    <img className={s.badgeImage} src={storeBadges[language] || storeBadges.enUS} alt="Google play" />
  </a>
);

export default GooglePlayBadge;
